<template>
  <div class="max-w-3xl mx-auto space-y-6">
    <Paragraph>
      {{ t("sla.intro") }}
      <Link href="/legal/service-level-agreement.pdf">
        {{ t("sla.full_version_link") }}
      </Link>
    </Paragraph>

    <Section :title="t('sla.webhosting_title')">
      <Paragraph>{{ t("sla.webhosting_text_1") }}</Paragraph>
      <Paragraph>{{ t("sla.webhosting_text_2") }}</Paragraph>
      <Paragraph>{{ t("sla.webhosting_text_3") }}</Paragraph>
      <Paragraph>{{ t("sla.webhosting_formula") }}</Paragraph>
      <Paragraph>{{ t("sla.webhosting_max_compensation") }}</Paragraph>
    </Section>

    <Section :title="t('sla.other_services_title')">
      <Paragraph>{{ t("sla.other_services_text_1") }}</Paragraph>
      <Paragraph>{{ t("sla.other_services_text_2") }}</Paragraph>
      <Paragraph>{{ t("sla.other_services_formula") }}</Paragraph>
    </Section>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import Section from "@/components/ui/Section.vue";
import Paragraph from "@/components/ui/Paragraph.vue";
import Link from "@/components/ui/Link.vue";

const { t } = useI18n();
</script>
